import { Modal } from "@/frontend/shared/ui/Modal";
import styles from "./EditSectionModal.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { ReactNode, RefObject } from "react";
import { CancelButton } from "@/frontend/shared/ui/Button/CancelButton/CancelButton";

type EditSectionModal = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title: string;
  width?: string;
  onSave?: () => void;
  saveButtonName?: string;
  modalContentRef?: RefObject<HTMLDivElement>;
  isLoading?: boolean;
  cancelButton?: ReactNode;
};

export function EditSectionModal({
  isOpen,
  onClose,
  children,
  title,
  width,
  modalContentRef,
  onSave,
  saveButtonName,
  isLoading,
  cancelButton
}: EditSectionModal) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || "Edit"} width={width || "540px"}>
      <div id="editModalContainer" style={{ position: "relative" }}>
        <div className={styles.modalContent} ref={modalContentRef}>
          {children}
        </div>
        <div className={styles.bottomSaveSection}>
          {cancelButton || (
            <CancelButton size="large" onClick={onClose}>
              Cancel
            </CancelButton>
          )}
          <NormalButton size="large" onClick={onSave} isSubmitting={isLoading}>
            {saveButtonName || "Save"}
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
}
